<template>
  <div :class="['FullscreenModal', { opened: opened }]">
    <div class="content">
      <slot name="cmp"></slot>
      <a class="close" href="#" @click.prevent="hide()">
        <img src="@images/close.svg">
      </a>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'FullscreenModal',
    methods: {
      show(){
        this.opened = true;
      },
      hide(){
        this.$emit('hide')
        this.opened = false;
      }
    },
    data(){
      return {
        opened: false
      }
    }
  };
</script>


<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/_fonts';

  .FullscreenModal{
    position: fixed;
    top: -100%;
    opacity: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    overflow-y:scroll;
    overflow-x:hidden;
    transition: all 0.3s ease-in-out;
    background-color: rgba(0,0,0,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    
    
    &.opened{
      top: 0;
      opacity: 1;
    }

    .close{
      position: absolute;
      top: 20px;
      right: 20px;
      width: 20px;
      height: 20px;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 100%;
      }
    }

    .content{
      padding: 30px 20px;
      width: 90%;
      margin-left: auto;
      .C;
      margin-right: auto;
      position: relative;
      background-color: #fff;
      @media (min-width: @bootstrap-md){
        max-width: 600px;
        padding: 60px 40px;
      }
    }
  }
</style>
